//import moment from 'moment'
import Vue from 'vue'
import Lessons from '../modules/lesson2.module'
import store from '../store';
import moment from 'moment'

export default class Day {
    /**
     * @var {moment|string|Date} date
     */
    localDate = '';

    /**
     * @var {string} title
     */
    localTitle = '';
    localTitles = [];

    /**
     * @var {string} description
     */
    localDescription = '';

    /**
     * @var {string} backgroundColor
     */
    localBackgroundColor = '';

    /**
     * @var {string} textColor
     */
    localTextColor = '';

    /**
     * @var {object} localData
     */
    localData = {};

    /**
     * Day constructor
     *
     * @var {moment|string|Date} date
     */
    constructor(date) {
        this.localDate = date;
        const holiday = this.isHoliday();
        if (holiday) {
            this.localTitle = holiday.title;
            this.localBackgroundColor = '#333';
            this.localTextColor = '#fff';
            this.localData.holiday = true;
        }
    }

    load(obj) {
        Object.assign(this, obj);
    }

    isMonday() {
        return this.localDate.isoWeekday() === 1;
    }

    isFriday() {
        return this.localDate.isoWeekday() === 5;
    }
    /**
     * Check if current day is a holiday
     */
    isHoliday() {
        return store.getters['rooster/holidays'].find((h) => {
            const localDate = moment(this.localDate);
            const holidayDate = moment(h.start_date);
            return (localDate.month() === holidayDate.month() && localDate.date() === holidayDate.date()) ||
                   localDate.isSame(h.start_date) ||
                   localDate.isBetween(h.start_date, h.end_date, 'day');
        });
    }

    autofill(cluster, type, start, verwerking, overwriteFriday, overwriteMonday) {
        if (this.isHoliday() || (this.isMonday() && !overwriteMonday) || (this.isFriday() && !overwriteFriday)) {
            return;
        }

        this.setColorFromType(type);
        if (typeof start !== 'number') {
            start = store.getters['rooster/lessonIndex'](cluster + '_' + type);
            store.commit('rooster/INCREASE_LESSON_INDEX', cluster + '_' + type);
        }

        const lesson = Lessons.getLesson(cluster, type, start);
        if (lesson) {
            this.localTitle = `${lesson.nummer}. ${lesson.titel}`;
            this.localData.lesson = true;
            this.localData.verwerkingsles = false;

            if (lesson.verwerkingsles) {
                const verwerkingsLes = lesson.verwerkingsles + "";
                const number = verwerkingsLes.indexOf('-') > -1 ? verwerkingsLes.split('-')[0] : verwerkingsLes;
                Vue.storage.set('verwerkingsles', {
                    lesson: this.getVerwerkingLes(cluster, type, number),
                    type,
                });
            }
        }
    }

    setColorFromType(type) {
        if (['advent', 'lijden', 'pasen', 'hemelvaart', 'pinksteren'].includes(type)) {
            this.localBackgroundColor = '#ffc107';
            this.localTextColor = '#000';
        }

        if (['kerk_en_zending', 'nederlandse_geloofsbelijdenis'].includes(type)) {
            this.localBackgroundColor = '#8000ff';
            this.localTextColor = '#fff';
        }
    }

    setVerwerking() {
        const verwerking = Vue.storage.get('verwerkingsles');
        Vue.storage.set('verwerkingsles', null);
        if (verwerking != null && verwerking) {
            const verwerkingsLes = verwerking.lesson;
            this.localTitle = `Verw. ${verwerkingsLes.nummer} ${verwerkingsLes.titel}`;
            this.localData.lesson = false;
            this.localData.verwerkingsles = true;
            this.setColorFromType(verwerking.type);
        }
    }

    getVerwerkingLes(cluster, type, number) {
        return Lessons.getLessonByNumber(cluster, type, number);
    }

    hasVerwerking() {
        return !!Vue.storage.get('verwerkingsles');
    }

    setLesson(background, textColor, title, titles) {
        this.localBackgroundColor = background;
        this.localTextColor = textColor;
        this.localTitle = title;
        this.localTitles = titles;
        this.localData.lesson = true;
        this.localData.verwerkingsles = false;
    }

    setHoliday(title) {
        this.localBackgroundColor = '#333';
        this.localTextColor = '#fff';
        this.localTitle = title;
        this.localData.holiday = true;
    }

    removeHoliday() {
        this.localBackgroundColor = '';
        this.localTextColor = '';
        this.localTitle = '';
        this.localData.holiday = false;
    }

    reset() {
        this.setLesson('', '', '', []);
    }
}